import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "state";

const selectSelf = (state: RootState) => state;
export const selectAppState = createSelector(selectSelf, state => state.app);
export const selectNavOpen = createSelector(selectAppState, app => app.navOpen);
